export const RA_REMARK_CODES = [
  {
    value: 'Exchange',
    label: 'Exchange',
  },
  {
    value: 'Refund',
    label: 'Refund',
  },
  {
    value: 'CF',
    label: 'Custom Free Text (Remember to note either Exchange or Refund)',
  }
];

export const RETURN_REASON_CODES = [
  {
    value: 'GR',
    label: 'GUARANTEE RETURN',
  },
  {
    value: 'CD',
    label: 'COURTESY DISCOUNT',
  },
  {
    value: 'CF',
    label: 'COURTESY FREIGHT',
  },
  {
    value: 'RF',
    label: 'REFUSED',
  },
  {
    value: 'TL',
    label: '3RD PARTY LOST BOX',
  },
  {
    value: 'EE',
    label: 'CSA ENTRY ERROR',
  },
  {
    value: 'SE',
    label: 'SYSTEM ERROR',
  },
  {
    value: 'WH',
    label: 'WAREHOUSE ERROR',
  },
];

export const RETURN_REASON_CODE_DETAILS = {
  'GR': [
    "Didn’t like color/print",
    "Didn’t like fabric",
    "Didn’t like style",
    "Didn't wash as expected",
    "Too large",
    "Too long",
    "Too short",
    "Too small",
    "Waistband Issues",
    "Gift return/exchange with proof of purchase",
    "Comfort (additional notes required)",
    "Other",
  ],
  'CD': [
    'Courier error',
    'Customer service error',
    'Inventory fill issue',
    'Outside 30-day CG',
    'Goodwill',
    'Price match',
    'Other'
  ],
  'CF': ['Courtesy Freight'],
  'RF': ['Refused'],
  'TL': ['Tracking shows delivered, but not received'],
  'EE': ['CSA Entry Error'],
  'SE': ['ERP System Error','OCA System Error','RAA System Error'],
  'WH': ['Wrong product shipped by warehouse']
}

export const PROVINCES = {
  'usa': [
    'Alabama',
    'Alaska',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'Florida',
    'Georgia',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming',
  ],
  'ca': [
    'Ontario',
    'Quebec',
    'British Columbia',
    'Alberta',
    'Manitoba',
    'Saskatchewan',
    'Nova Scotia',
    'New Brunswick',
    'Newfoundland and Labrador',
    'Prince Edward Island',
    'Northwest Territories',
    'Nunavut',
    'Yukon',
  ],
};
export const REGIONS = [
  {
    code: 'ca',
    title: 'Canada',
  },
  {
    code: 'usa',
    title: 'USA',
  },
  {
    code: 'amazon_usa',
    title: 'Amazon US',
  },
];
export const SHOPIFY_ADDRESS_FIELDS = {
  'country': 'Country',
  'company': 'Company',
  'first_name': 'First Name',
  'last_name': 'Last Name',
  'address1': 'Address 1',
  'address2': 'Address 2',
  'city': 'City',
  'province': 'Province',
  'zip': 'Zip',
  'phone': 'Phone',
};
// LogOn Constants
export const WAREHOUSE_RETURN_MAXIMUM_AMOUNT = 100;
export const LOGON_RA_REMARKS_MAX_LENGTH = 25;
export const LOGON_STATUS_MAP = {
  'P': 'Pick Ticket',
  'A': 'Allocated',
  'N': 'No Action',
  'I': 'Invoiced',
  'C': 'Cancelled',
};
export const LOGON_STATUS_PICK_TICKET = 'pick-ticket';
export const LOGON_STATUS_IN_ALLOCATION = 'in-allocation';
export const LOGON_STATUS_NO_ACTION = 'no-action';
export const D365_STATUS_INVOICED = 'Invoiced';
export const LOGON_STATUS_CANCELLED = 'cancelled';
export const LOGON_STATUS_INVOICED_OR_CANCELLED = 'invoiced-or-cancelled';
export const LOGON_STATUS_IN_ALLOCATION_OR_PICK_TICKET = 'in-allocation-or-pick-ticket';
export const LOGON_STATUS_UNKNOWN = 'unknown-status';
export const LOGON_STATUS_ICU = [
  LOGON_STATUS_INVOICED_OR_CANCELLED,
  D365_STATUS_INVOICED,
  LOGON_STATUS_CANCELLED,
  LOGON_STATUS_UNKNOWN,
];
export const LOGON_STATUS_PT = [
  LOGON_STATUS_IN_ALLOCATION_OR_PICK_TICKET,
  LOGON_STATUS_IN_ALLOCATION,
  LOGON_STATUS_PICK_TICKET,
];
// Return Authorization
export const ORDER_RETURN_MINIMUM_SUBTOTAL_REFUND_AMOUNT = 0;
export const ORDER_RETURN_MINIMUM_TOTAL_REFUND_AMOUNT = 0;
export const ORDER_RETURN_MINIMUM_PRODUCT_QUANTITY = 0;
export const ORDER_RETURN_MINIMUM_SHIPPING_PRICE = 0;
export const ORDER_DISCOUNT_WARNING_THRESHOLD = 3;